var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-img",style:({ backgroundImage: _vm.imgSrc, width:_vm.formatSize, height:_vm.formatSize, borderRadius:_vm.radius })},[(_vm.$slots.default)?_c('div',{staticClass:"ui-img-tools"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }